import { tw } from '@/utils/tw';
import BaseRichTextBox from 'base/components/RichTextBox/theme';

const RichTextBox = tw.theme({
  extend: BaseRichTextBox,
  base: [
    'mx-auto',
    'max-w-content',
    'p-grid-m',
    'rounded-2xl',
    'group-data-[page=static]/main:max-w-article',
    'group-data-[page=static]/main:mx-0',
  ],
});

export default RichTextBox;
